import { print } from "graphql";
import { Viproc } from "@/models/viproc";
import { BaseAPI } from "@/api/base.api";
import { Tramitation } from "@/models/tramitation";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { map } from "rxjs/operators";

const tramitacao = require("@/query/arproc/Tramitacao.graphql");

export class TramitationAPI extends BaseAPI<Tramitation> {
  constructor() {
    super();
    this.apiUrl = `${this.apiUrl}/tramitacao`;
  }

  public findByViproc(
    viproc: Viproc,
    page: Number,
    size: Number
  ): AxiosObservable<Tramitation> {
    const data = {
      inputProcesso: { ...viproc },
      inputPage: {
        page: page,
        size: size,
        sort: [""],
        ascendingSort: true
      }
    };

    return this.axios
      .post(`${this.graphqlUrl}`, {
        query: print(tramitacao),
        variables: data
      })
      .pipe(
        map((data: any) => {
          const { tramitacao } = data;
          return tramitacao;
        })
      );
  }

  public findByProcessoId(
    processoId: number,
    page: Number,
    size: Number
  ): AxiosObservable<Tramitation> {
    const data = {
      id: processoId,
      inputPage: {
        page: page,
        size: size,
        sort: [""],
        ascendingSort: true
      }
    };

    return this.axios
      .post(`${this.graphqlUrl}`, {
        query: print(tramitacao),
        variables: data
      })
      .pipe(
        map((data: any) => {
          const { tramitacao } = data;
          return tramitacao;
        })
      );
  }
}
